<template>
  <q-dialog v-model="showDialog" persistent>
    <q-card>
      <q-bar dens class="bg-primary text-white">
        <div>{{ barTitle }}</div>
        <q-space></q-space>
        <q-btn v-close-popup text-color="white" color="red" dense icon="close">
          <q-tooltip class="bg-white text-primary">Close</q-tooltip>
        </q-btn>
      </q-bar>
      <q-form ref="userStockForm" @submit="onSubmit" class="q-mt-md">
        <div class="q-pa-md row q-gutter-x-md">
          <div class="col-md-11 col-sm-11 col-xs-11">
            <q-select
              @filter="filterBrokerFn"
              label="Client Code"
              :disable="isUpdating"
              v-model="userStocks.client_code"
              :options="clientCodeOptions"
              :rules="[(val) => val != '']"
              clearable
              error-message="Please select Client Code"
              use-input
              option-value="id"
              option-label="client_code"
              outlined
              dense
            ></q-select>
          </div>
          <div class="col-md-11 col-sm-11 col-xs-11">
            <q-select
              v-model="userStocks.symbol"
              :options="optionSymbols"
              use-input
              hide-selected
              clearable
              dense
              fill-input
              input-debounce="0"
              option-value="symbol"
              option-label="symbol"
              emit-value
              stack-label
              map-options
              :rules="[(val) => val != null]"
              error-message="Please select a Symbol"
              @filter="filterSymbol"
              label="Symbol"
              outlined
            >
              <template v-slot:no-option>
                <q-item>
                  <q-item-section class="text-grey">
                    No results
                  </q-item-section>
                </q-item>
              </template>
            </q-select>
          </div>
          <div
            class="row col-md-11 col-sm-11 justify-between"
            v-show="userStocks.auto_execution"
          >
            <div class="col-md-4 col-sm-4 col-xs-12">
              <q-select
                @filter="filterBrokerFn"
                label="Type"
                v-model="userStocks.auto_execution_order_type"
                :rules="autoExecution ? [(val) => val != null] : false"
                :options="typeOption"
                clearable
                error-message="Please Type of execution"
                use-input
                option-value="id"
                option-label="type"
                outlined
                dense
              ></q-select>
            </div>
            <div
              class="col-md-4 col-sm-4 col-xs-12"
              v-if="userStocks.auto_execution_order_type?.type === 'BUY'"
            >
              <q-input
                v-model="userStocks.buy_target"
                :rules="autoExecution ? [(val) => val > 150] : false"
                label="Buy Target"
                type="number"
                error-message="Buy Target should be greater than 150"
                outlined
                dense
              />
            </div>
            <div
              class="col-md-4 col-sm-4 col-xs-12"
              v-if="userStocks.auto_execution_order_type?.type === 'SELL'"
            >
              <q-input
                v-model="userStocks.sell_target"
                :rules="autoExecution ? [(val) => val != ''] : false"
                label="Sell Target"
                type="number"
                outlined
                dense
              />
            </div>
            <div
              class="col-md-3 col-sm-3 col-xs-12"
              v-if="
                userStocks.auto_execution_order_type?.type === 'SELL' ||
                userStocks.auto_execution_order_type?.type === 'BUY'
              "
            >
              <q-input
                v-model="userStocks.quantity"
                :rules="autoExecution ? [(val) => val != ''] : false"
                label="Quantity"
                type="number"
                error-message="Please enter a quantity"
                outlined
                dense
              />
            </div>
          </div>

          <div class="col-11 text-center">
            <div class="row justify-center">
              <q-btn
                style="max-width: 130px"
                dense
                class="q-ma-md col-grow col-md-4"
                :label="btnLabel"
                type="submit"
                color="primary"
              />
            </div>
          </div>
        </div>
        <q-checkbox
          v-if="autoExecution"
          v-show="false"
          v-model="userStocks.auto_execution"
          label="Auto Execution"
          class="q-ma-md"
        />
      </q-form>
    </q-card>
  </q-dialog>
  <div class="q-px-md q-mt-md" v-if="!isUpdating">
    <q-btn
      color="primary"
      unelevated
      :label="stocksBtn"
      icon-right="add_circle_outline"
      @click="openDialog()"
      no-caps
    />
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useQuasar } from "quasar";

const emit = defineEmits(["submitForm"]);
const props = defineProps({
  clientCodes: {
    type: Array,
  },
  allStocks: {
    type: Array,
  },
  isUpdating: {
    type: Boolean,
  },
  stocksBtn: {
    type: String,
  },
  autoExecution: {
    type: Boolean,
    default: false,
  },
  barTitle: {
    type: String,
  },
  btnLabel: {
    type: String,
  },
});
const optionSymbols = ref(props.allStocks);
const typeOption = ref([
  { id: 1, type: "BUY" },
  { id: 2, type: "SELL" },
]);
const clientCodeOptions = ref(props.clientCodes);
const userStocks = ref({
  client_code: "",
  symbol: null,
  auto_execution: props.autoExecution ? true : false,
  auto_execution_order_type: "",
});
const userStockForm = ref(null);
const $q = useQuasar();
const showDialog = ref(false);
let id = "";
const barTitle = ref(props.barTitle);
const btnLabel = ref(props.btnLabel);
btnLabel.value = props.stocksBtn ? "Submit" : btnLabel.value;
const filterBrokerFn = function (val, update) {
  if (val === "") {
    update(() => {
      clientCodeOptions.value = props.clientCodes;
    });
    return;
  }

  update(() => {
    const needle = val.toLowerCase();
    clientCodeOptions.value = props.clientCodes.filter((v) => {
      return v.client_code.toLowerCase().indexOf(needle) > -1;
    });
  });
};

const isFormValid = computed(() => {
  if (!userStocks.value.client_code || !userStocks.value.symbol) {
    return false;
  }

  // if (userStocks.value.auto_execution) {
  //   if (
  //     !userStocks.value.type &&
  //     !userStocks.value.buy_target &&
  //     !userStocks.value.sell_target
  //   ) {
  //     return false;
  //   }
  // }

  return true;
});

const filterSymbol = (searchText, update) => {
  if (searchText === "") {
    update(() => {
      optionSymbols.value = props.allStocks;
    });
    return;
  }
  update(() => {
    const needle = searchText.toLowerCase();
    optionSymbols.value = props.allStocks.filter((s) => {
      return (
        s?.symbol.toLowerCase().indexOf(needle) > -1 ||
        s?.name.toLowerCase().indexOf(needle) > -1
      );
    });
  });
};

const onSubmit = async () => {
  try {
    const success = await userStockForm.value.validate();
    if (props.autoExecution) {
      userStocks.value.auto_execution_order_type = userStocks.value.buy_target
        ? "BUY"
        : "SELL";
    }
    if (!props.isUpdating) {
      userStocks.value["client_code"] = userStocks.value.client_code.id;
    } else {
      userStocks.value["client_code"] = userStocks.value.client_code;
    }
    if (success) {
      emit("submitForm", { ...userStocks.value, id: id });
      showDialog.value = false;
      userStocks.value = {};
    } else {
      console.error("Form validation failed");
    }
  } catch (error) {
    const message = error?.response?.data?.message;
    $q.notify({
      message: message || "",
      type: "negative",
    });
    console.error("An error occurred during form submission:", error);
  }
};
const openDialog = (data) => {
  showDialog.value = true;
  userStocks.value.auto_execution = props.autoExecution ? true : false;
  if (data) {
    userStocks.value.client_code = data.client;
    userStocks.value.symbol = data.symbol;

    if (props.autoExecution) {
      userStocks.value.quantity = data.quantity;
      barTitle.value = "Update Auto Buy/Sell";
      btnLabel.value = "Update";
      if (data?.buy_target) {
        userStocks.value.buy_target = data?.buy_target;
        userStocks.value.auto_execution_order_type = { id: 1, type: "BUY" };
      }
      if (data?.sell_target) {
        userStocks.value.sell_target = data?.sell_target;
        userStocks.value.auto_execution_order_type = { id: 2, type: "SELL" };
      }
    } else {
      barTitle.value = "Update User Stocks";
      btnLabel.value = "Update";
    }
    id = data.id;
  }
};
defineExpose({ openDialog });
</script>
